// @flow
import React, { useState, useEffect, useCallback } from "react";
import { Card, CardBody, Button, CardTitle, Col, Row, Alert } from "reactstrap";
import { Link, useCurrentRoute, useNavigation } from "react-navi";
import templateService from "../../services/api/templateService";
import { TemplateView } from "./templateView";
import Paginator from "../components/Paginator";
import TemplateSearch from "./templateSearch";
import { encodeUrlParams } from "../../services/utils";
import Container from "../components/Container";
import CardsDisplay from "../components/CardsDisplay";

export function Templates() {
  const [templates, setTemplates] = useState([]);
  const [searchParameters, setSearchParameters] = useState(null);
  const route = useCurrentRoute();
  const navigation = useNavigation();

  async function handleDelete(event) {
    event.persist();
    const confirm = window.confirm(
      "Are you sure you want to delete this template?"
    );
    if (!confirm) return;
    const result = await templateService.deleteTemplate(event.target.value);
    if (result) {
      navigation.navigate("/templates");
    }
  }

  function handleSearch(searchParameters) {
    setSearchParameters(searchParameters);
  }

  useEffect(() => {
    setTemplates(route.data.data);
  }, [route.data]);

  const templateCards = templates.map(template => {
    const actions = (
      <React.Fragment>
        <Col>
          <Link
            className=" btn-black btn-block btn btn-outline-dark"
            href={`/templates/${template._id}`}
          >
            Modify
          </Link>
        </Col>
        <Col>
          <Button
            outline
            className=" btn-red btn-block btn btn-outline-danger"
            onClick={handleDelete}
            value={template._id}
          >
            Delete
          </Button>
        </Col>
      </React.Fragment>
    );
    return <TemplateView actions={actions} template={template} />;
  });

  return (
    <Container title="Configuration templates">
      <Link
        href="/templates/create"
        className="btn btn-black btn-block btn-outline-dark"
      >
        Create template
      </Link>
      <TemplateSearch onChange={handleSearch} />
      <hr className="hr-black" />

      <CardsDisplay
        searchParams={searchParameters}
        endpoint="templates"
        pages={route.data}
        cards={templateCards}
      />
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/views/template/templates.jsx